import { render } from "./ListPosts.vue?vue&type=template&id=73ba7dba"
import script from "./ListPosts.vue?vue&type=script&lang=js"
export * from "./ListPosts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Devs\\Fullstack\\NewDeal\\vue_app_api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__